import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PAGLogin from "./components/Login3";
import PAGLayout from "./components/PAGLayout";
import IAQ from "./components/IAQ";
import MainAnalytics from "./components/Historical";
import Dashboard from "./components/Dashboard";
import Gym from "./components/Gym";
import Concierge from "./components/Concierge";
import FloorPlan from "./components/FloorPlan";
import UserManagement from "./components/user";
import DeviceManagement from "./components/DeviceMangement";

// Protected Route Component
const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If specific roles are required, check if user has one of them
  if (requiredRoles.length > 0 && !requiredRoles.includes(user.role)) {
    // Redirect to dashboard if user doesn't have required role
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// Role-based route wrapper for Access Roles (Admin and Global Admin only)
const AdminRoute = ({ children }) => (
  <ProtectedRoute requiredRoles={["Admin", "Global Admin"]}>
    {children}
  </ProtectedRoute>
);

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Login route without sidebar */}
        <Route path="/login" element={<PAGLogin />} />
        
        {/* Protected routes with sidebar layout */}
        <Route path="/*" element={
          <ProtectedRoute>
            <PAGLayout>
              <Routes>
                {/* Redirect root (/) directly to /dashboard */}
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/iaq" element={<IAQ />} />
                <Route path="/historical" element={<MainAnalytics />} />
                <Route path="/gym" element={<Gym />} />
                <Route path="/concierge" element={<Concierge />} />
                <Route path="/floorplan" element={<FloorPlan />} />
                <Route path="/devices" element={<DeviceManagement />} />
                
                {/* Role-restricted route for Access Roles (Admin and Global Admin only) */}
                <Route 
                  path="/roles" 
                  element={
                    <AdminRoute>
                      <UserManagement />
                    </AdminRoute>
                  } 
                />
              </Routes>
            </PAGLayout>
          </ProtectedRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
};

export default App;